import Vue from 'vue';

interface FormField {
	label: string;
	value: any;
}

interface Form {
	username: FormField;
	apartment: FormField;
	phone: FormField;
	email: FormField;
}

export default Vue.extend({
	data () {
		return {
			dialog_admin: false,
			admin_in_dialog: false,
			check: ['white'],

			aa_tabs1_1: null,
			aa_tabs1_2: null,
			aa_tabs1_3: null,
			aa_tabs1_4: null,
			aa_tabs1_5: null,
			aa_tabs2_1: null,
			aa_tabs2_2: null,
			aa_tabs2_3: null,
			aa_tabs2_4: null,
			aa_tabs3_1: null,
			aa_tabs3_2: null,
			aa_tabs3_3: null,
			aa_tabs4_1: null,
			aa_tabs4_2: null,

			form: {
				username: {
					label: "", // i18n 키로 대체될 예정
					value: null
				},
				apartment: {
					label: "", // i18n 키로 대체될 예정
					value: null
				},
				phone: {
					label: "", // i18n 키로 대체될 예정
					value: null
				},
				email: {
					label: "", // i18n 키로 대체될 예정
					value: null
				},
			} as Form
		}
	},

	created() {
		this.updateFormLabels();
	},

	watch: {
		// 언어가 변경될 때마다 폼 라벨을 업데이트합니다.
		'$i18n.locale'() {
			this.updateFormLabels();
		}
	},

	methods:
		{
			updateFormLabels() {
				this.form.username.label = this.$t('ServicePages.AdminAdvantage.form.name') as string;
				this.form.apartment.label = this.$t('ServicePages.AdminAdvantage.form.company') as string;
				this.form.phone.label = this.$t('ServicePages.AdminAdvantage.form.phone') as string;
				this.form.email.label = this.$t('ServicePages.AdminAdvantage.form.email') as string;
			},

			HANDLE_SEND_SLACK() {
				if (!this.isPrivacyAgreed()) return;
				if (!this.areRequiredFieldsFilled()) return;

				const type = this.$t('ServicePages.AdminAdvantage.slack.manualRequestType') as string;
				const content = this.createContentMessage(type);
				this.sendSlackMessage(content);
			},

			isPrivacyAgreed(): boolean {
				if (this.check.length < 2) {
					// [수정] this.$t의 결과를 string으로 타입 캐스팅
					this.$toasted.show(this.$t('ServicePages.AdminAdvantage.toasts.agreePrivacy') as string);
					return false;
				}
				return true;
			},

			areRequiredFieldsFilled(): boolean {
				const requiredFields: (keyof Form)[] = ['username', 'apartment', 'email'];
				for (const key of requiredFields) {
					if (this.form[key].value === null) {
						// [수정] this.$t의 결과를 string으로 타입 캐스팅
						this.$toasted.show(this.$t('ServicePages.AdminAdvantage.toasts.fillField', { field: this.form[key].label }) as string);
						return false;
					}
				}
				return true;
			},

			createContentMessage(type: string): string {
				const title = this.$t('ServicePages.AdminAdvantage.slack.requestMessageTitle', { type: type });
				const contentArr = [title];

				Object.keys(this.form).forEach(key => {
					const typedKey = key as keyof Form;
					const value = this.form[typedKey].value;
					const label = this.form[typedKey].label;

					contentArr.push(this._.sprintf("%s: %s", [label, value]));
				});

				return contentArr.join('\n');
			},

			resetFormValues() {
				Object.keys(this.form).forEach(key => {
					const typedKey = key as keyof Form;
					this.form[typedKey].value = null;
				});
				this.check = ['white'];
			},

			sendSlackMessage(content: string) {
				this.$aws.lambda.invoke(
					process.env.VUE_APP_AWS_LAMBDA_CREATE_MESSAGE_SLACK as string,
					'RequestResponse',
					JSON.stringify({
						action: 'OFFICIAL',
						content: content
					})
				).then( res => {
					this.resetFormValues();
					this.admin_in_dialog = true;
				});
			}
		},
	computed:
		{
			usePrivacy() {
				return process.env.VUE_APP_PRIVACY;
			}
		}
});